
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"660","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M576.771 5.96c20.753 2.465 41.504 4.929 83.13 5.04H0v-.9c20.437 0 30.655-.974 40.874-1.949 10.218-.975 20.436-1.95 40.873-1.95 20.437 0 30.656.975 40.874 1.95 10.218.975 20.437 1.95 40.874 1.95s30.655-.975 40.873-1.95c10.219-.975 20.437-1.95 40.874-1.95 20.439 0 30.657.975 40.875 1.95 10.215.975 20.429 1.95 40.856 1.95 41.61.114 62.481-2.238 83.352-4.59C431.196 3.157 452.067.805 493.677.92c41.601.113 62.349 2.576 83.094 5.04z","fill":"currentColor"}})])
          )
        }
      }
    